document.addEventListener("DOMContentLoaded", () => {
  const scrollBtn = document.querySelector(".scroll-to-top");
  if (!scrollBtn) return;

  scrollBtn.addEventListener("click", (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  // Toggle visibility after scrolling 300px
  window.addEventListener("scroll", () => {
    if (window.scrollY > 300) {
      scrollBtn.classList.add("visible");
    } else {
      scrollBtn.classList.remove("visible");
    }
  });
});
